import i18n from "../i18n.js";

export default {
  install(Vue) {
    Vue.prototype.$secondaryNav = {
      toolsNavItems: {
        customer: function () {
          return [
            {
              title: i18n.t("Test Categorization"),
              url: `/customer/settings/tools`,
              disabled: false,
            },
            {
              title: i18n.t("Recategorize Domain"),
              url: `/customer/settings/tools/recategorize_domain`,
            },
          ];
        },

        system: function () {
          return [
            {
              title: i18n.t("Test Categorization"),
              url: `/system/global_settings/tools`,
              disabled: false,
            },
            {
              title: i18n.t("Recategorize Domain"),
              url: `/system/global_settings/tools/recategorize_domain`,
            },
            {
              title: i18n.t("DNS Lookup"),
              url: `/system/global_settings/tools/dns_lookup`,
            },
          ];
        },

        msp: function () {
          return [
            {
              title: i18n.t("Test Categorization"),
              url: `/msp/global_settings/tools`,
              disabled: false,
            },
            {
              title: i18n.t("Recategorize Domain"),
              url: `/msp/global_settings/tools/recategorize_domain`,
            },
            {
              title: i18n.t("DNS Lookup"),
              url: `/msp/global_settings/tools/dns_lookup`,
            },
          ];
        },
      },

      customerDefaultPolicyNavItems: function () {
        const navItems = [
          {
            title: i18n.t("Policy Details"),
            url: `/customer/settings/default_policy`,
          },
          {
            title: i18n.t("Allowed & Blocked Domains"),
            url: `/customer/settings/default_policy/domains`,
          },
          {
            title: i18n.t("Notifications"),
            url: `/customer/settings/default_policy/notifications`,
          },
        ];

        return navItems;
      },

      customerGroupNavItems: function () {
        const navItems = [
          {
            title: i18n.t("All Groups"),
            url: `/customer/environment/groups`,
          },
          {
            title: i18n.t("Group Ranking"),
            url: `/customer/environment/groups-ranking`,
          },
        ];

        return navItems;
      },

      customerPolicyNavItems: function (id, showDevices = true) {
        const navItems = [
          {
            title: i18n.t("Policy Details"),
            url: `/customer/content_filtering/policies/${id}`,
          },
          {
            title: i18n.t("Allowed & Blocked Domains"),
            url: `/customer/content_filtering/policies/${id}/domains`,
          },
          {
            title: i18n.t("Notifications"),
            url: `/customer/content_filtering/policies/${id}/notifications`,
          },
          {
            title: i18n.t("Locations"),
            url: `/customer/content_filtering/policies/${id}/locations`,
          },
        ];

        if (showDevices)
          navItems.push({
            title: i18n.t("Devices"),
            url: `/customer/content_filtering/policies/${id}/devices`,
          });

        return navItems;
      },
    };
  },
};
